import UserManager from "src/core/manager/user-manager/user-manager";

const defaultAccessCheck = (projectId, task) => {
    if (task)   return gd.ac.check.project.standardAccess(task.projectId) || task.actionRequiredUserId === gd.session.me.id;
    else        return gd.ac.check.project.standardAccess(projectId)
}

// const debug = "ac.check.task"
const debug = false

module.exports = {

    editDeadline(projectId, task)       {return defaultAccessCheck(projectId, task)},
    editStartEnd(projectId, task)       {return defaultAccessCheck(projectId, task)},
    editARUser(projectId, task)         {return defaultAccessCheck(projectId, task)},
    editAssignedToUser(projectId, task) {return defaultAccessCheck(projectId, task)},
    editStatusPriority(projectId, task) {return defaultAccessCheck(projectId, task)},
    editTaskType(projectId, task)       {return defaultAccessCheck(projectId, task)},

    editSchedule(projectId, task) {

        // if (!task) return false

        // no edit schedule if no AR user
        if (task && !task.actionRequiredUserId) {
            debug && console.log(debug, "No task or no AR -> false")
            return false;
        }

        const meId = gd.session.me.id;

        // AR user is self user
        if (task && task.actionRequiredUserId === gd.user.id)   return true;

        // project full access
        if (gd.ac.check.project.fullAccess(task ? task.projectId : projectId))  return true;

        // Manager access
        const userManager = new UserManager();
        if (task && userManager.isManagerForUser(task.actionRequiredUserId)) {
            return true;
        }

        // check if AR users report to me
        let reportsToMe = false;
        if (task) {
            gd.session.companyUsers.map(cu=>{
                if (cu.reportToUserId === meId && cu.user.id === task.actionRequiredUserId) reportsToMe = true;
            });
        }
        if (reportsToMe) {
            return true
        }

        debug && console.log(debug, "No access -> False")
        return false
    },

    editEstimate(projectId, task) {
        if (gd.const.systemStatus.isClosed(task.systemStatus)) return false;

        const isArUser = task.actionRequiredUserId === gd.session.me.id;
        const isCreatorUser = task.createdByUserId === gd.session.me.id;

        return isArUser || isCreatorUser || gd.ac.check.project.fullAccess(projectId);
    },

    canDelete(projectId, project) {

        let res = false;
        if (projectId) {

            let projectAccess = 0, companyId, sProject;
            try {
                sProject = project ? project : gd.session.projects.get(projectId);
                projectAccess = sProject.access;
                companyId = sProject.companyId;
            } catch(e) {
                console.error("Check rules task canDelete error:", projectId, sProject);
            }

            if (!gd.session.companies.get(companyId)) return false;

            res = (projectAccess >= gd.const.project.access.FULL);
        }

        return res;
    },

    canDuplicate(projectId, project) {
        let res = false;
        if (projectId) {

            let projectAccess = 0, companyId, sProject;
            try {
                sProject = project ? project : gd.session.projects.get(projectId);
                projectAccess = sProject.access;
                companyId = sProject.companyId;
            } catch(e) {
                console.error("Check rules task canDuplicate error:", projectId, sProject);
            }

            if (!gd.session.companies.get(companyId)) return false;

            // let organizationRole = gd.session.companies.get(companyId).role;

            res = (projectAccess >= gd.const.project.access.STANDARD/* ||
                    organizationRole >= gd.const.companyRole.MANAGER*/);
        }

        return res;
    },

    // deprecated user gd.ac.task.editStoryPoints
    editStoryPoints(projectId, task) {
        if (gd.const.systemStatus.isClosed(task.systemStatus)) return false;

        const isArUser = task.actionRequiredUserId === gd.session.me.id;
        const isCreatorUser = task.createdByUserId === gd.session.me.id;

        return isArUser || isCreatorUser || gd.ac.check.project.fullAccess(projectId);
    }
};